import Link from 'next/link';
import styled from 'styled-components';

import { ellipsis } from '~lib/styles/Theme/common';

export const RecentCommentWrapper = styled.section`
  width: 652px;
  margin-left: 242px;

  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    width: 100%;
    margin-left: 0;
  }
`;

export const RecentCommentHead = styled.h2`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.H4};
  line-height: 38.48px;
  color: ${({ theme }) => theme.colors.gray900};
  text-align: left;

  ${({ theme }) => theme.media.mobile} {
    font-size: ${({ theme }) => theme.fontSize.T1};
  }
`;

export const RecentCommentList = styled.div`
  margin-top: 20px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 4px;

  ${({ theme }) => theme.media.mobile} {
    margin-top: 15px;
  }

  > * + * {
    border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  }
`;

export const RecentCommentItemWrapper = styled.a`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;

  font-size: ${({ theme }) => theme.fontSize.B3};
  color: ${({ theme }) => theme.colors.gray900};
  font-weight: ${({ theme }) => theme.fontWeight.normal};

  ${({ theme }) => theme.media.mobile} {
    flex-wrap: wrap;
    align-content: space-between;
    padding: 20px 15px;
    height: 98px;
  }

  > div {
    text-align: left;
  }
`;

export const ArrowBox = styled.div`
  background: ${({ theme }) => theme.colors.gray400};
  border-radius: 2px;
  display: inline-block;
  color: ${({ theme }) => theme.colors.magenta700};
  font-size: ${({ theme }) => theme.fontSize.C2};
  text-align: center;
  height: 16px;
  line-height: 16px;
  padding: 0 8px;
  margin-left: 9px;
  position: relative;

  > .arrow {
    position: absolute;
    right: 100%;
    top: 4px;
    transform: rotate(270deg);
    height: 7px;
    overflow: hidden;

    &:after {
      content: '';
      margin-top: 4px;
      background-color: ${({ theme }) => theme.colors.gray400};
      height: 7px;
      width: 7px;
      display: block;
      border-top-right-radius: 30%;
      transform: rotate(-55deg) skewX(-20deg);
    }
  }
`;

export const CommentCompany = styled.div`
  ${ellipsis()}
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  ${({ theme }) => theme.media.with('tablet', 'pc')} {
    padding: 0 30px;
    flex: 0 0 160px;
  }

  ${({ theme }) => theme.media.mobile} {
    order: 1;
    width: 135px;
    margin-right: auto;
  }
`;

export const CommentSubject = styled.div`
  display: flex;
  overflow: hidden;
  ${({ theme }) => theme.media.pc} {
    flex: 1;
    font-weight: 400;
  }

  > p {
    ${ellipsis()}
  }

  ${({ theme }) => theme.media.mobile} {
    order: 4;
    width: 100%;
    font-size: ${({ theme }) => theme.fontSize.B2};
  }
`;

export const CommentName = styled.div`
  ${ellipsis()}

  ${({ theme }) => theme.media.with('tablet', 'pc')} {
    flex: 0 0 120px;
    padding: 0 20px;
    margin-left: auto;
  }

  ${({ theme }) => theme.media.mobile} {
    order: 2;
    max-width: 77px;
    margin-right: 10px;
    font-size: ${({ theme }) => theme.fontSize.C1};
  }
`;

export const CommentDate = styled.div`
  ${({ theme }) => theme.media.with('tablet', 'pc')} {
    flex: 0 0 115px;
    padding-left: 20px;
  }

  ${({ theme }) => theme.media.mobile} {
    order: 3;
    font-size: ${({ theme }) => theme.fontSize.C1};
  }
`;
